import { isProdBEnv } from '@/utils/isProdBEnv';

/** 正式 B 主色（医美） */
export const PROD_B_PRIMARY = '#FB7E7E';

/** 正式 A / 测试默认主色 */
export const DEFAULT_PRIMARY = '#1890ff';

export function brandPrimaryColor(): string {
  return isProdBEnv() ? PROD_B_PRIMARY : DEFAULT_PRIMARY;
}
